import React from 'react';

const ClientsLoadingPage = () => {
	return <></>;
};

export default ClientsLoadingPage;
